import PropTypes from 'prop-types'
import { UNIT_TYPES } from 'constants'

export const UnitDataPropTypes = PropTypes.shape({
    clan: PropTypes.object.isRequired,
    commander_nickname: PropTypes.string.isRequired,
    created_at: PropTypes.number.isRequired,
    fort_battle_in_progress: PropTypes.bool.isRequired,
    in_battle: PropTypes.bool.isRequired,
    is_destroyed: PropTypes.bool,
    players_matching_started_at: PropTypes.number,
    legionaries_number: PropTypes.number.isRequired,
    max_legionaries_number: PropTypes.number.isRequired,
    max_members_number: PropTypes.number.isRequired,
    locked_slots_number: PropTypes.number.isRequired,
    max_vehicle_level: PropTypes.number.isRequired,
    members_number: PropTypes.number.isRequired,
    periphery: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
    type: PropTypes.oneOf(Object.keys(UNIT_TYPES)).isRequired,
})

export const VehiclePropTypes = PropTypes.shape({
    dailyXPFactor: PropTypes.number,
    iconUrl: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    isPremium: PropTypes.bool,
    isTopConfiguration: PropTypes.bool,
    level: PropTypes.number,
    name: PropTypes.string.isRequired,
    nation: PropTypes.string.isRequired,
    shortName: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
})



// WEBPACK FOOTER //
// ./containers/BattleRooms/propTypes.js